// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__20TWg","row":"Node_row__2xO03","label":"Node_label__3JG63","footer":"Node_footer__9yPIp"};